import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

import Theme from "./Modules/Theme/Theme";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Theme
  },
  plugins: [createPersistedState()],
})
